import { render } from "./OfferSupplement.vue?vue&type=template&id=07fe0990&scoped=true&ts=true"
import script from "./OfferSupplement.vue?vue&type=script&lang=ts"
export * from "./OfferSupplement.vue?vue&type=script&lang=ts"

import "./OfferSupplement.vue?vue&type=style&index=0&id=07fe0990&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07fe0990"]])

export default __exports__